import { useGetInteractionOptions } from '../../../services/configManager';
import {
  useGetApprovedAmount,
  useGetConsumer,
} from '../../../services/flowManager';

export const useApplyConfig = () => {
  const approvedAmount = useGetApprovedAmount();
  const consumer = useGetConsumer();
  const {
    apply: isApplyAllowed,
    applyLink,
    applyQrCode,
    applySms,
  } = useGetInteractionOptions();

  const shouldShowApplySendLink = applyLink || applyQrCode || applySms;

  return {
    isApplyAllowed,
    shouldShowApplySendLink,
    shouldShowApplySection: !consumer && !approvedAmount,
  };
};
